<template>
  <b-container class="login-container" fluid>
    <b-row align-h="center" class="login-form">
      <div class="col-md-3 login-form-2">
        <b-form @submit.prevent="login">
          <div class="avatar">
              <!--<b-icon icon="person-square"></b-icon>-->
              <img src="images/logo_utb_50_a.png" alt="logo 50" class="rounded-circle mx-auto" style="width: 95px;">
          </div>
          <h2 class="text-center">Información visitantes</h2>
          <div class="form-group">
            <b-form-input name="identificacion" placeholder="Identificación" v-model="credentials.identificacion"></b-form-input>
          </div>
          <div class="form-group">
            <b-form-input name="nombre" placeholder="Nombre" autocomplete="off" v-model="credentials.nombre"></b-form-input>
          </div>
          <div class="form-group">
            <b-form-input type="email" name="email" placeholder="Email" v-model="credentials.email"></b-form-input>
          </div>
          <div class="form-group">
            <b-button type="submit" block>Ingresar</b-button>
          </div>
        </b-form>
        <!--p class="text-center small">Don't have an account? <a href="#">Sign up here!</a></p-->
      </div>
    </b-row>
  </b-container>
</template>

<script lang="ts">
import { oauth } from '../../services/oauth_service'
import { Vue, Component } from 'vue-property-decorator'

@Component
export default class Visitante extends Vue {
  
  credentials: any = {}

  async login() {
    let self = this
    try {
      let path = await oauth.guestLogin(this.credentials)
      self.$router.push({ path })
    } catch (ex) {
      //console.log(ex.response)
      this.$bvToast.toast(
        ex.response?.status === 401 ? 'Credenciales inválidas' : 'Error desconocido',
        {
          title: 'Ha ocurrido un error',
          variant: 'danger',
        }
      )
    }
  }

  created() {
    this.credentials = {}
    if (oauth.logged()) {
      //this.$router.push({ name: 'dashboard' })
    }
  }
}
</script>

<style lang="scss">
.login-container {
  color: #fff;
  background: #002E82;
  height: calc(100vh);
}
.form-control {
  min-height: 41px;
  background: #fff;
  box-shadow: none !important;
  border-color: #e3e3e3;
}
.form-control:focus {
  border-color: #70c5c0;
}
.form-control,
.btn {
  border-radius: 2px;
}
.login-form {
  /*width: 350px;*/
  margin: 0 auto;
  padding: 100px 0 30px;

  & form {
    color: #7a7a7a;
    border-radius: 2px;
    margin-bottom: 15px;
    font-size: 13px;
    background: #ececec;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    padding: 30px;
    position: relative;
  }
  & h2 {
    font-size: 22px;
    margin: 35px 0 25px;
  }
  & .avatar {
    position: absolute;
    margin: 0 auto;
    left: 0;
    right: 0;
    top: -50px;
    width: 95px;
    height: 95px;
    border-radius: 50%;
    z-index: 9;
    //background: #70c5c0;
    // padding: 15px;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
    color: #ffffff;
    text-align: center;
    vertical-align: middle;
  }
  & input[type='checkbox'] {
    margin-top: 2px;
  }
  & .btn {
    font-size: 14px;
    font-weight: bold;
    border: none;
    margin-bottom: 20px;
  }
  & .btn:hover,
  & .btn:focus {
    background: #50b8b3;
    outline: none !important;
  }
  & a {
    color: #fff;
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  }

  & form a {
    color: #7a7a7a;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }

  & .form-control {
    min-height: 41px;
    background: #fff;
    box-shadow: none !important;
    border-color: #e3e3e3;
  }
  & .form-control:focus {
    border-color: #70c5c0;
  }
  & .form-control,
  & .btn {
    border-radius: 2px;
  }
}
</style>